import React from "react";
import PageHeader from "../common/HeaderPage";
import Card from "react-bootstrap/Card";
import CardGroup from "react-bootstrap/CardGroup";
export default function ERPPage() {
  return (
    <section
      id="content"
      className="container clearfix"
      style={{
        padding: "0px",
        outline: "none",
        margin: "0px auto",
        marginBottom: "0px"
      }}
    >
      <PageHeader title={"Enterprise Resource Planning"}></PageHeader>

      <CardGroup>
        <Card>
          <Card.Img variant="top" />
          <Card.Body>
            <Card.Title>Inventory</Card.Title>
            <Card.Text>
              Inventory Management
              <ul className="noBullets">
                <li>Receivables</li>
                <li>Shipping</li>
                <li>Storage Tracking</li>
                <li>Consumption</li>
                <li>Bill of Materials</li>
                <li>Inventory Levels</li>
                <li>Zone Storage</li>
                <li>Storage Optimization</li>
                <li>Smart Alerts</li>
              </ul>
              <ul>
                <li>Web interface</li>
                <li>Mobile driven</li>
              </ul>
            </Card.Text>
          </Card.Body>
          <Card.Footer>
            <small className="text-muted">Demo in progress</small>
          </Card.Footer>
        </Card>

        <Card>
          <Card.Img variant="top" />
          <Card.Body>
            <Card.Title>Housing</Card.Title>
            <Card.Text>
              Housing Work Management
              <ul className="noBullets">
                <li>Work Order Scheduling</li>
                <li>Work Allocation</li>
                <li>Work Time tracking</li>
                <li>Material Consumption</li>
                <li>Work Progress</li>
                <li>Work Visibility</li>
                <li>Rule Constraints</li>
                <li>Smart Alerts</li>
              </ul>
              <ul>
                <li>Web interface</li>
                <li>Mobile driven</li>
              </ul>
            </Card.Text>
          </Card.Body>
          <Card.Footer>
            <small className="text-muted">Demo in progress</small>
          </Card.Footer>
        </Card>
      </CardGroup>
      <div style={{ margin: "0px", padding: "0px", outline: "none" }}>
        <p
          style={{
            margin: "0px",
            padding: "0px",
            outline: "none",
            marginBottom: "20px"
          }}
        >
          <br></br>
          <br></br>
          <h4>Common Features</h4>
          We value your security and privacy. Our cloud based MTD software is
          designed with security in mind, ensuring that your data is protected
          at all times.
          <ul>
            <li>Our software has enhanced security.</li>
            <li>Enjoy enterprise security level.</li>
            <li>You are in control of your fillings and data.</li>
            <li>On prem or cloud solution.</li>
          </ul>
        </p>
      </div>
    </section>
  );
}
